<script lang="ts">
	import type { TrafficInformationEvent } from '../traffic/types';
	import TrafficAd from '$lib/components/advertising/TrafficAd.svelte';
	import NoTraffic from '$lib/components/traffic/NoTraffic.svelte';
	import * as m from '$paraglide/messages';
	import { mapTrafficEventTypeToScheme } from '../traffic/constants';
	import TrafficCard from '../traffic/TrafficCard.svelte';

	export let events: TrafficInformationEvent[];
	export let withSeoTraffic: boolean;
	export let isLoading = false;

	// Put index at second position if there are more than 1 ad, otherwise put it last
	$: adIndex = events.length > 1 ? 1 : events.length - 1;
</script>

<div class="bg-neutral-weakest">
	<div class="flex flex-col gap-4 p-2 items-center">
		<div class="border-neutral-soft border-0.5 border-solid" />
		{#if isLoading}
			<TrafficCard isLoading />
			<TrafficCard isLoading />
			<TrafficCard isLoading />
		{:else if events?.length}
			<!-- eslint-disable-next-line svelte/require-each-key -->
			{#each events as event, index}
				<TrafficCard
					scheme={mapTrafficEventTypeToScheme[event.type]}
					info={event.description ?? undefined}
				/>
				{#if index === adIndex}
					<TrafficAd />
				{/if}
			{/each}
		{:else}
			<NoTraffic
				text={withSeoTraffic
					? m.alerts_traffic_panel__no_events__label()
					: m.alerts_traffic_panel__select_location__label()}
				refresh={withSeoTraffic}
				on:retry
			/>
			<TrafficAd />
		{/if}
	</div>
</div>
